export const setValueByUID = (state, uid, value) => {
  if (!uid || !state) {
    return
  }

  try {
    let formattedUID = String(uid)

    if (formattedUID.includes('##')) {
      formattedUID = String(uid.split('##')[1])
    }

    const rootKey = formattedUID.includes(':')
      ? 'state' // page field logic || page params logic
      : 'params' // global params

    return state.setIn([rootKey, ...formattedUID.split(':')], value)
  } catch (error) {
    console.warn('error while setting field value >>> ', error)

    return state
  }
}
